import script from "./HeadingEmphasis.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeadingEmphasis.vue?vue&type=script&setup=true&lang=ts"

import "./HeadingEmphasis.vue?vue&type=style&index=0&id=cc9a1c20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc9a1c20"]])

export default __exports__